export const EDITION_BT_LINK = "https://www.businesstimes.com.sg/";
export const EDITION_BTI_LINK = "https://www.businesstimesintl.com/";
